<template>
    <div class="w-full md:w-1/2 lg:w-1/3">
        <div>
            <jet-label value="Category" />
            <multiselect
                class="multi-sm h-7 text-base"
                v-model="form.category"
                :options="categories"
                placeholder="All"
                searchable
                :create-option="true"
                @change="handleSubmit"
            />
        </div>

        <div>
            <jet-label value="Title" />
            <jet-input type="text" class="h-7 w-full" v-model="form.title" ref="title" required/>
            <jet-input-error class="mt-1" :message="$page.props.errors.title" />
        </div>

        <div class="mt-2">
            <jet-label value="Description"  />
            <textarea v-model="form.description" class="block rounded w-full h-20" maxlength="1000" rows="4" required></textarea>
            <jet-input-error class="mt-1" :message="$page.props.errors.description" />
        </div>
    </div>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import Multiselect from '@vueform/multiselect';

import '@vueform/multiselect/themes/default.css';

export default {
    components: {
        JetInput,
        JetInputError,
        JetLabel,
        Multiselect,
    },

    props: ['form', 'categories'],

    data() {
        return {
            //
        }
    },

    methods: {
        //
    },

    computed: {
        //
    },

    watch: {
        //
    },

    mounted () {
        if (this.form.id === null) {
            this.$refs.title.focus();
        }
    }
}
</script>

<style>
.dp-custom-input {
    @apply h-8;
}
.box>* {
    flex: 1 1 300px;
}
</style>

<style scoped>
input:active.disabled,
input:focus.disabled,
input:hover.disabled,
input.disabled {
    @apply bg-gray-300;
}
</style>
